/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_SubpathInputs */

const en_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform Subpath`)
};

const es_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subruta de la plataforma`)
};

const fr_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-chemin de la plateforme`)
};

const de_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform-Unterpfad`)
};

const ja_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォームのサブパス`)
};

const zh_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台子路径`)
};

const ar_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المسار الفرعي للمنصة`)
};

const id_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subpath Platform`)
};

const it_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottopercorso Piattaforma`)
};

const ru_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутренний путь платформы`)
};

const pt_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subcaminho da Plataforma`)
};

const ko_platform_subpath = /** @type {(inputs: Platform_SubpathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랫폼 서브도메인 경로`)
};

/**
* | output |
* | --- |
* | "Platform Subpath" |
*
* @param {Platform_SubpathInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const platform_subpath = /** @type {((inputs?: Platform_SubpathInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_SubpathInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_platform_subpath(inputs)
	if (locale === "es") return es_platform_subpath(inputs)
	if (locale === "fr") return fr_platform_subpath(inputs)
	if (locale === "de") return de_platform_subpath(inputs)
	if (locale === "ja") return ja_platform_subpath(inputs)
	if (locale === "zh") return zh_platform_subpath(inputs)
	if (locale === "ar") return ar_platform_subpath(inputs)
	if (locale === "id") return id_platform_subpath(inputs)
	if (locale === "it") return it_platform_subpath(inputs)
	if (locale === "ru") return ru_platform_subpath(inputs)
	if (locale === "pt") return pt_platform_subpath(inputs)
	return ko_platform_subpath(inputs)
});